import gql from 'graphql-tag';

export const SAVE_ORGANIZATION = gql`
  mutation SaveOrganization($input: OrganizationInput!) {
    saveOrganization(input: $input) {
      organization {
        id
        name
        website
        timezone
        address
        addressTwo
        city
        state
        zip
        country
        slug
      }
      errors {
        code
        message
        property
      }
    }
  }
`;

export const AREAS_OF_MINISTRY = gql`
  query AreasOfMinistry {
    areaOfMinistries {
      id
      key
      label
    }
  }
`;

export const SAVE_SUBSCRIBER = gql`
  mutation NewSaveSubscriber($input: SubscriberInput!) {
    newSaveSubscriber(input: $input) {
      errors {
        code
        message
        property
      }
    }
  }
`;
